import React, { Component } from "react";
import { useQuery } from "@apollo/react-hooks";
import ReactPlayer from "react-player";
import { MdPlayCircleOutline } from "react-icons/md";
import { TiArrowLeft } from "react-icons/ti";
import * as serviceWorker from "../../serviceWorker";
import { SINGLE_VIDEO_QUERY } from "./../../lib/graphqlQueries";

import "./index.less";

const getVideoDetails = (video, props) => {
  const {
    content,
    title,
    mediaDetails: { videoThumbnail: { sourceUrl } = {} } = {},
    videoSettings: { videoUrl }
  } = video;

  const { goBack, currentlyPlaying, playVideo, videoId } = props;
  const showVideoPreview = !currentlyPlaying || currentlyPlaying !== videoId;
  return (
    <article>
      {showVideoPreview && (
        <div className="video-post-image-container">
          <div className="container video-title-container">
            <TiArrowLeft
              className="back-button"
              color="white"
              onClick={goBack}
            />
            <img src={sourceUrl} alt="Thumbnail" />
            <div className="video-title">
              <div>{title}</div>
            </div>
          </div>
          <MdPlayCircleOutline
            className="play-icon"
            color="white"
            onClick={() => playVideo(videoId)}
          />
          <div className="darkgradient" />
        </div>
      )}
      {!showVideoPreview && (
        <div className="video-post-image-container">
          <div className="container video-title-container">
            <TiArrowLeft
              className="back-button"
              color="white"
              onClick={goBack}
            />
            <ReactPlayer url={videoUrl} width="100%" playing />
          </div>
        </div>
      )}
      <div className="video-description clearfix">
        <div
          className="container"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </article>
  );
};

export default props => {
  const { videoId } = props;
  const variables = { videoId };
  const { data, loading, error } = useQuery(SINGLE_VIDEO_QUERY, {
    variables
  });
  const { videoBy } = data || {};

  let videoDetails = "";
  if (loading) return <p>Loading...</p>;
  if (error) {
    serviceWorker.unregister();
    return <p>Error getting data: Please reload your page.</p>;
  }
  if (!videoBy) return <p>No matching posts found.</p>;
  if (videoBy) videoDetails = getVideoDetails(videoBy, props);
  return <section className="video-post">{videoDetails}</section>;
};
